import React from "react";
import BalanceChecker from "../components/balance-checker/BalanceChecker";
import { SimulationProvider } from "../contexts/Simulation";

function BalanceCheckerPage() {
  return (
    <SimulationProvider>
      <BalanceChecker />
    </SimulationProvider>
  );
}

export default BalanceCheckerPage;
